<footer class="footer fixed-bottom ">
  <div  style="background: #fff">
    <p class="text-muted text-center">Tüm hakları saklıdır © {{currentYear}} <br> TSK Mehmetçik Vakfı</p>

  </div>

</footer>
